import { Placeholder, Report } from './report.interface';

export const formPlaceholders: Placeholder = {
  /**
   *formPlaceholders it labels placeholder with translation string.
   **/
  reportForm: {
    reportOn: 'report-form.labels.report_on',
    reportOf: 'report-form.labels.report_of',
    startDate: 'report-form.labels.start_date',
    endDate: 'report-form.labels.end_date',
    submit: 'report-form.labels.submit',
  },
};

export const sxmReports: Report = {
  /**
   *sxmReports it contains 'placeholder' as label with translation string and its value 'reportName' in the html template,
   * The value in the object is mean to api header value.
   **/
  reportOn: 'sxm',
  placeholder: 'report-on.labels.sxm',
  reportOf: [
    {
      reportName: 'ProductsReport',
      placeholder: 'report-of.labels.sxm.products',
      value: 'Y',
    },
    {
      reportName: 'VehiclesReport',
      placeholder: 'report-of.labels.sxm.vehicles',
      value: 'Y',
    },
    {
      reportName: 'SubscriptionReport',
      placeholder: 'report-of.labels.sxm.subscription',
      value: 'Y',
    },
    {
      reportName: 'AccountsReport',
      placeholder: 'report-of.labels.sxm.accounts',
      value: 'Y',
    },
    {
      reportName: 'RetailDeliveryReport',
      placeholder: 'report-of.labels.sxm.retail_delivery',
      value: 'Y',
    },
    {
      reportName: 'PaymentTransactionReport',
      placeholder: 'report-of.labels.sxm.payment_transaction',
      value: 'Y',
    },
    {
      reportName: 'PaymentSourceReport',
      placeholder: 'report-of.labels.sxm.payment_source',
      value: 'Y',
    },
  ],
};

export const telematicsReports: Report = {
  /**
   *telematicsReports it contains 'placeholder' as label with translation string and its value 'reportName' in the html template,
   * The value in the object is mean to api header value.
   **/
  reportOn: 'telematics',
  placeholder: 'report-on.labels.telematics',
  reportOf: [
    {
      reportName: 'EnrollReport',
      placeholder: 'report-of.labels.telematics.enroll',
      value: 'Y',
    },
    {
      reportName: 'SsrReport',
      placeholder: 'report-of.labels.telematics.ssr',
      value: 'Y',
    },
  ],
};

export const tciReports: Report = {
  /**
   *tciReports it contains 'placeholder' as label with translation string and its value 'reportName' in the html template,
   * The value in the object is mean to api header value.
   **/
  reportOn: 'tci',
  placeholder: 'report-on.labels.tci',
  reportOf: [
    {
      reportName: 'TciReport',
      placeholder: 'report-of.labels.tci.tci',
      value: 'Y',
    },
  ],
};
